'use strict';

var Hounisen = Hounisen || {};
Hounisen.universeAccordion = new function () {

    function init() {
        // Init functions
        UniverseAccordion();
        UniverseArticlesAccordion();
    }

    function UniverseAccordion() {
        var headers = document.querySelectorAll('.uaccordion__item__accordion-item__header, .uaaccordion__item__aaccordion-item__header, .uaccordion__section-button, .uaa__section-button');

        Array.prototype.forEach.call(headers, function(header) {
            header.addEventListener('click', function () {
                var content = this.nextElementSibling;
                var childWith2ndClass = this.querySelector('[class*="2nd"]');

                // Toggle the display of the content
                if (content.style.maxHeight) {
                    content.style.maxHeight = null;

                    // dont reset the bold font weight if the header has the class bold
                    if (!header.classList.contains("bold")) {
                        header.style.fontWeight = "500";
                    }

                    // Reset the rotation of childWith2ndClass
                    if (childWith2ndClass) {
                        childWith2ndClass.style.transform = "rotate(0deg)";
                    }
                }
                else {
                    //dont apply the bold font weight if the header has the class bold
                    if (!header.classList.contains("bold")) {
                        header.style.fontWeight = "bold";
                    }

                    content.style.maxHeight = content.scrollHeight + "px";

                    // Rotate childWith2ndClass 90 degrees
                    if (childWith2ndClass) {
                        childWith2ndClass.style.transform = "rotate(90deg)";
                    }
                }
            });
        });
    }



    function UniverseArticlesAccordion ()
    {
        var headers = document.querySelectorAll('.uaa__item__accordion-item__header');

        Array.prototype.forEach.call(headers, function(header) {
            header.addEventListener('click', function () {

                //adds ands removes the open class
                if(header.classList.contains("open"))
                {
                    header.classList.remove("open");
                }
                else {
                    header.classList.add("open");
                }

                headers.forEach(function (header) {

                    var childWith2ndClass = header.querySelector('[class*="2nd"]');
                    var headerId = header.getAttribute("data-id");
                    var elements = document.querySelectorAll('.uaa__item__content[data-id="' + headerId + '"]');

                    if(header.classList.contains("open")){

                        header.style.fontWeight = "bold";
                        childWith2ndClass.style.transform = "rotate(90deg)";

                        elements.forEach(function (element) {
                            element.style.maxHeight = element.scrollHeight + "px";
                        });

                    }
                    else {

                        //loop through all elements and set the display to block
                        elements.forEach(function (element) {
                            element.style.maxHeight = "0px";
                        });

                        header.style.fontWeight = "500";
                        childWith2ndClass.style.transform = "rotate(0deg)";
                    }

                });

            });
        });

    }


    return {
        init: init,
    };
}();
